/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author  Jaroslav Pribyl    (pribyl@cadwork.cz)
 *
 */

import {EEmbededElementTypes, RenderDocument} from "js_renderer";
import PoiPicker from "./poi_picker";

export default
class GeoElementsPicker extends PoiPicker {
    constructor(aRenderDocument: RenderDocument)
    {
        super(aRenderDocument);

        this._supportedTypes = [
            EEmbededElementTypes.GEOPOINT,
            EEmbededElementTypes.GEOPATH
        ];
    }
}
